import React from "react";
import { observer } from "mobx-react";
import { PaginatorContainer } from "./Paginator.styled";
import { Pagination } from "@ann/web-components";

const Paginator = observer(() => {
  return (
    <PaginatorContainer>
      <Pagination
        currentPage={1}
        itemsPerPage={5}
        onItemsPerPageChange={() => {}}
        onPageChange={() => {}}
        totalItems={25}
        totalPages={5}
      />
    </PaginatorContainer>
  );
});

export default Paginator; 